import Icon from "@ant-design/icons";

const ShareIconSVG = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0868 3.29329H4.75342C4.48008 3.29329 4.25342 3.51996 4.25342 3.79329C4.25342 4.06663 4.48008 4.29329 4.75342 4.29329H10.0868C11.6468 4.29329 12.9201 5.56663 12.9201 7.12663C12.9201 8.68663 11.6468 9.95996 10.0868 9.95996H2.75342C2.48008 9.95996 2.25342 10.1866 2.25342 10.46C2.25342 10.7333 2.48008 10.96 2.75342 10.96H10.0868C12.2001 10.96 13.9201 9.23996 13.9201 7.12663C13.9201 5.01329 12.2001 3.29329 10.0868 3.29329Z"
      fill="url(#paint0_linear_731_2132)"
    />
    <path
      d="M4.28654 8.29341C4.15988 8.29341 4.03321 8.34008 3.93321 8.44008L2.22654 10.1467C2.03321 10.3401 2.03321 10.6601 2.22654 10.8534L3.93321 12.5601C4.12654 12.7534 4.44654 12.7534 4.63988 12.5601C4.83321 12.3667 4.83321 12.0467 4.63988 11.8534L3.28654 10.5001L4.63988 9.14674C4.83321 8.95341 4.83321 8.63341 4.63988 8.44008C4.54654 8.34008 4.41321 8.29341 4.28654 8.29341Z"
      fill="url(#paint1_linear_731_2132)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_731_2132"
        x1="2.25342"
        y1="7.12663"
        x2="13.9201"
        y2="7.12663"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_731_2132"
        x1="2.08154"
        y1="10.4992"
        x2="4.78488"
        y2="10.4992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
    </defs>
  </svg>
);
const ShareIcon = (props) => <Icon component={ShareIconSVG} {...props} />;

export default ShareIcon;
